import React, { useState, useEffect } from "react";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import StyledProductWrapper from "./style";
import { useNavigate, useLocation } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { ButtonFilled } from "../../reusableComponent/UIButtons";
import { ReactComponent as Tick } from "../../../src/assets/Icons/Tick.svg";

const footerStyle = {
  position: "fixed",
  bottom: 0,
  left: "270px",
  right: 0,
  backgroundColor: "#fff",
  padding: "10px",
  display: "flex",
  justifyContent: "end",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  margin: "0px 0px",
};

const AddNewProductList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const isEditMode =
    location.pathname.includes("/edit") || location.state?.isEdit || false;

  const handleFormSubmit = () => {
    const message = isEditMode ? "Updated" : "Created";
    setModalMessage(message);
    setIsModalVisible(true);
  };

  const handleSelectChange = (value, fieldName) => {
    console.log("Selected plan:", value);
  };

  useEffect(() => {
    if (isModalVisible) {
      setTimeout(() => {
        setIsModalVisible(false);
        navigate("/productlist");
      }, 2000);
    }
  }, [isModalVisible, navigate]);

  const PlanData = [
    { value: "basic", label: "Basic" },
    { value: "lite", label: "Lite" },
    { value: "pro", label: "Pro" },
  ];

  const addNewProductForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [],
        fields: [
          [
            {
              id: 1,
              label: "Product Name:",
              type: "text",
              name: "product_name",
              Placeholder: "Enter Product Name",
              maxLength: 50,
              onKeyDown: /^[a-zA-Z\s]+$/,
              validationRules: [
                { required: true, message: "Product name is required" },
                {
                  min: 0,
                  max: 50,
                  // message: "Company name must be within 50 alphabetic characters",
                },
                // {
                //   pattern: /^[a-zA-Z\s]*$/,
                //   // message: "Company name cannot contain numbers or special characters",
                // },
              ],
            },
          ],
          [
            {
              id: 2,
              label: "Description",
              type: "textarea",
              name: "description",
              // options: PlanData,
              Placeholder: "Enter Description",
              validationRules: [
                { required: true, message: "Description is required" },
              ],
            },
          ],
        ],
      },
    ],
  };

  return (
    <>
      <StyledProductWrapper>
        <div className="mb-4">
          <div>
            <h5 className="view_product_goback">
              <p onClick={() => navigate("/productlist")}>Product List</p>{" "}
              <RightOutlined className="right_out_icon" />{" "}
              <storng className="!bg-[red]">
                {isEditMode ? "Editing Product List" : "Adding Product List"}
              </storng>{" "}
            </h5>
          </div>
          <>
            <GridBuilder
              formStructureJson={addNewProductForm}
              handleSelectChange={handleSelectChange}
            />
          </>
          <>
            <div className="text-right form_button_section" style={footerStyle}>
              <ButtonFilled type="primary" onClick={handleFormSubmit}>
                {isEditMode ? "Update" : "Create"}
              </ButtonFilled>
            </div>
          </>
        </div>

        <Modal
          open={isModalVisible}
          footer={false}
          closable={false}
          centered
          width={300}
        >
          <div style={{ textAlign: "center" }}>
            <p
              style={{
                fontSize: "18px",
                marginBottom: "20px",
              }}
            >
              <Tick style={{ width: "50px", height: "50px" }} />
              <br />
              {modalMessage}
            </p>
          </div>
        </Modal>
      </StyledProductWrapper>
    </>
  );
};

export default AddNewProductList;
